<template>
    <div
        :style="[cssProperties]"
        :class="[
            'quote-card',
            theme,
            {
                pc: isPc
            }
        ]"
    >
        <div class="swiper card-list" ref="swiper">
            <div class="swiper-wrapper">
                <div class="card swiper-slide" v-for="(stock, index) in list" :key="index">
                    <div class="name">
                        <p class="text-over limit-2">
                            {{ stock.name }}
                        </p>
                    </div>
                    <p
                        :class="[
                            'price',
                            {
                                flat: stock.priceChange == 0,
                                up: stock.priceChange > 0,
                                down: stock.priceChange < 0
                            }
                        ]"
                    >
                        {{ stock.price }}
                    </p>
                    <p
                        :class="[
                            'quote',
                            {
                                flat: stock.priceChange == 0,
                                up: stock.priceChange > 0,
                                down: stock.priceChange < 0
                            }
                        ]"
                    >
                        <span class="change">{{ `${stock.priceChange > 0 ? '+' : ''}` + stock.priceChange }}</span>
                        <span class="radio">{{ `${stock.priceChange > 0 ? '+' : ''}` + stock.ratioPriceChange }}</span>
                    </p>
                    <SparkChart
                        v-if="chartDatas[stock.stockId]"
                        class="chart"
                        :dataSource="chartDatas[stock.stockId]"
                        :upDowmColorConfig="upDowmColorConfig"
                    />
                </div>
            </div>
        </div>
        <template v-if="showShadow">
            <div class="shadow left"></div>
            <div class="shadow right"></div>
        </template>
    </div>
</template>

<script>
import request from '../assets/scripts/request';
import '@futuweb/quote-charts/lib/SparkChart/style/index.css';
import core from './core';
export default {
    name: 'quote-card',
    mixins: [core],
    data() {
        return {
            isPreRender: window.FEGORender.common.env.isPreRender
        };
    },
    async created() {
        await this.getRankList();
        if (!this.isPreRender) {
            this.initChartData();
            this.$nextTick(this.initSwiper);
        }
    },
    methods: {
        // 获取具体市场排行榜数据
        async getMarketRank() {
            const data = {
                sort_id: this.sort_id,
                market_id: this.market_id,
                lang: this.language,
                count: this.count,
                platform: this.platform
            };
            try {
                const commonApiRequest = request.bindCommonApi('quote-rank-v2');
                return await commonApiRequest.get('get-rank-list', data);
            } catch (err) {
                console.error('market-rank', err);
            }
        },
        // 获取自定义排行榜数据
        async getCustomRank() {
            const data = {
                stockIds: this.stockIdsStr,
                lang: this.language,
                count: this.count
            };
            try {
                const commonApiRequest = request.bindCommonApi('quote-rank-v2');
                return await commonApiRequest.get('get-custom-rank-list', data);
            } catch (err) {
                console.error('custom-rank', err);
            }
        },
        // 初始化图表数据
        initChartData() {
            if (!this.stockList || !this.stockList.length) {
                return;
            }
            this.stockList.map(async (stock) => {
                const chartData = (await this.getChartData(stock)) || [];
                this.$set(this.chartDatas, stock.stockId, chartData);
            });
        },
        // 获取图表数据
        async getChartData(stock) {
            const params = {
                stock_id: stock.stockId,
                market_code: stock.marketCode,
                type: 1,
                req_section: 0 // 盘中数据
            };
            const commonApiRequest = request.bindCommonApi('quote-rank-v2');
            const r = await commonApiRequest.get('quote-minute', params);
            const priceChange = Number(stock.priceChange);
            // eslint-disable-next-line no-nested-ternary
            r.price_direct = priceChange > 0 ? 'up' : priceChange < 0 ? 'down' : 'flat';
            return r;
        }
    }
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
